<template>
  <b-modal
    id="edit-user-profile"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="editUserProfile"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Editar perfil
    </template>

    <template v-slot:default>

      <AlertWraper
        :content="errors"
        type="error"
      />

      <form
        action=""
        method="POST"
        @submit.prevent="submit"
      >
        <div class="mb-4">
          <h2 class="font-weight-bold font-size-regular text-center text-md-left">Foto de perfil</h2>

          <div
            id="profileWrap"
            class="background-cover author-image-circle image-lg mx-auto d-flex align-items-center justify-content-center"
            :style="profileImage"
          >
            <input
              type="file"
              id="avatar"
              name="avatar"
              style="display: none;"
              @change="changeAvatar"
              accept="image/*"
            />
            <label for="avatar" class="cursor-pointer font-size-medium text-white">
              <i class="fa fa-camera"></i>
            </label>
          </div>

          <div class="mt-3 text-center">
            <Button
              class="btn-primary btn-sm btn-outline-color2"
              @click="$bvModal.show('select-avatar')"
            >
              Selecionar modelo
            </Button>
          </div>
        </div>
        <AvatarSelectModal
          @avatar-selected="setDefaultAvatar"
        />
        <div class="mb-4">
          <h2 class="font-weight-bold font-size-regular text-center text-md-left">Foto de capa</h2>

          <div
            id="coverWrap"
            class="background-cover rounded-regular mx-auto d-flex align-items-center justify-content-center"
            :style="coverImage"
          >
            <input
              type="file"
              id="cover"
              name="avatar"
              style="display: none;"
              @change="changeCover"
              accept="image/*"
            />
            <label for="cover" class="cursor-pointer font-size-medium text-white">
              <i class="fa fa-camera"></i>
            </label>
          </div>
          <p class="font-size-xSmall mt-1 text-color2  text-center text-lg-left">Tamanho ideal: 1110px x 280px</p>
           <div class="mt-3 text-center">
            <Button
              @click="$bvModal.show('select-cover')"
              class="btn-primary btn-sm btn-outline-color2"
            >
              Selecionar modelo
            </Button>
          </div>
        </div>
         <CoverSelectModal
          :type="'user_default_cover'"
          @cover-selected="setDefaultCover"
        />

        <div class="mb-4">
          <h2 class="font-weight-bold font-size-regular text-center text-md-left">Nome</h2>
          <input
            type="text"
            class="form-control bordered-bottom font-size-small w-100 text-left"
            v-model.trim="$v.profile.name.$model"
          />
        </div>

        <div class="mb-4">
          <h2 class="font-weight-bold font-size-regular text-center text-md-left">Biografia</h2>
          <textarea
            class="form-control bordered-bottom font-size-small w-100 text-left"
            v-model.trim="profile.description"
          ></textarea>
          <p class="font-size-small text-right">
            <span
              class="d-inline-block"
              :class="{
                'text-color4': profile.description.length > 700
              }"
            >
              {{ profile.description.length }}
            </span>/700
          </p>
        </div>

        <div>
          <h2 class="font-weight-bold font-size-regular text-center text-md-left">Social</h2>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">Twitter</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://twitter.com/username"
                  v-model.trim="profile.social.twitter"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">Instagram</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://instagram.com/username"
                  v-model.trim="profile.social.instagram"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">Facebook</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://facebook.com/username"
                  v-model.trim="profile.social.facebook"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">LinkedIn</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://www.linkedin.com/in/username"
                  v-model.trim="profile.social.linkedin"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">YouTube</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://www.youtube.com/username"
                  v-model.trim="profile.social.youtube"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="font-weight-bold font-size-small mb-0">Link externo</label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small w-100 text-left"
                  placeholder="https://www.exemplo.com.br"
                  v-model.trim="profile.social.external"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 text-center">
          <Button
            class="btn-primary"
            type="submit"
            :loading="loader"
            :disabled="$v.$invalid"
          >
            Salvar
          </Button>
        </div>

      </form>
    </template>
  </b-modal>
</template>

<script>

import UsersService from '@/modules/users/services/users-service'
import { required } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import AvatarSelectModal from '@/components/common/Avatar/AvatarSelectModal'
import Button from '@/components/common/Button/Button.vue'
import CoverSelectModal from '@/components/common/Cover/CoverSelectModal'

export default {
  name: 'UserEditProdifleModal',
  props: ['user'],
  mixins: [variables],
  components: {
    AlertWraper,
    Button,
    CoverSelectModal,
    AvatarSelectModal
  },
  data () {
    return {
      profile: {
        name: '',
        description: '',
        cover: null,
        avatar: null,
        social: {
          twitter: '',
          facebook: '',
          linkedin: '',
          instagram: '',
          youtube: '',
          external: ''
        },
        user_default_cover: '',
        user_default_avatar: ''
      },
      loader: false,
      errors: null,
      defaultCover: null,
      defaultAvatar: null
    }
  },
  validations () {
    return {
      profile: {
        name: { required }
      }
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    },
    coverImage () {
      let url = ''
      if (this.defaultCover) {
        url = this.defaultCover.url
      } else if (this.profile.cover) {
        url = URL.createObjectURL(this.profile.cover)
      } else {
        url = this.user ? this.user.cover : this.noCoverUrl
      }

      return {
        backgroundImage: `url('${url}')`
      }
    },
    profileImage () {
      let url = ''
      if (this.defaultAvatar) {
        url = this.defaultAvatar.url
      } else if (this.profile.avatar) {
        url = URL.createObjectURL(this.profile.avatar)
      } else {
        url = this.user ? this.user.avatar : this.noAvatarUrl
      }

      return {
        backgroundImage: `url('${url}')`
      }
    }
  },
  created () {
    this.updateLocalProfile()
  },
  watch: {
    user (newUser, oldUser) {
      this.updateLocalProfile()
    }
  },
  methods: {
    updateLocalProfile () {
      if (this.user) {
        this.profile.name = this.user.name
        this.profile.description = this.user.description ? this.profile.description : ''
        this.profile.social.twitter = this.user.social.twitter
        this.profile.social.linkedin = this.user.social.linkedin
        this.profile.social.facebook = this.user.social.facebook
        this.profile.social.instagram = this.user.social.instagram
        this.profile.social.youtube = this.user.social.youtube
        this.profile.social.external = this.user.social.external
      }
    },
    changeCover (e) {
      const file = e.target.files[0]

      // Change default cover to blank
      this.defaultCover = null
      this.profile.cover = file

      this.profile.user_default_cover = null
    },
    changeAvatar (e) {
      const file = e.target.files[0]
      // Change default avatar to blank
      this.defaultAvatar = null
      this.profile.user_default_avatar = null

      this.profile.avatar = file
    },
    async submit () {
      this.loader = true
      this.errors = null

      try {
        await UsersService.update(this.user.id, this.profile)
        UsersService.me()
        this.$bvModal.hide('edit-user-profile')
        this.$emit('profile-updated')
      } catch (error) {
        const { data } = error.response
        this.errors = data.errors
        this.$refs.editUserProfile.$refs.modal.scrollTop = 0
      }
      this.loader = false
    },
    hidden () {
      this.errors = null
      this.defaultCover = null
      this.defaultAvatar = null
    },
    // Add default cover
    setDefaultCover (cover) {
      this.profile.cover = null
      this.defaultCover = cover
      this.profile.user_default_cover = cover.id
    },
    // Add default avatar
    setDefaultAvatar (avatar) {
      this.profile.avatar = null
      this.defaultAvatar = avatar
      this.profile.user_default_avatar = avatar.id
    }
  }
}
</script>

<style lang="scss" scoped>
#coverWrap {
  height: 150px;
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    background: rgba(0,0,0,0.2);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }

  label {
    position: relative;
    z-index: 2;
  }
}
#profileWrap {
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    background: rgba(0,0,0,0.2);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }
  label {
    position: relative;
    z-index: 2;
  }
}
</style>
